module.exports = __webpack_public_path__ + "img/older_design.c8fd6b9c.png";